import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
export interface TransferPayload {
  record: any;
  data: any;
}
@Injectable({
  providedIn: 'root',
})
export class VerificationPatchService {
  private selectedRecord$ = new BehaviorSubject<TransferPayload | null>(null);
  readonly activeRecord$ = this.selectedRecord$.asObservable();

  sendRecordToVerification(record: any,data:any): void {
    console.log('Service: Broadcasting record downstream:', record);
    this.selectedRecord$.next({ record, data });
  }
  clearRecord(): void {
    this.selectedRecord$.next(null);
  }
}
